export const SONGDATA = 
[
    {
      "name": "Life Goes On",
      "spotify": "https://open.spotify.com/track/5FVbvttjEvQ8r2BgUcJgNg",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/5827da47ea5ef2d768e7f9dc8226182080c7a99f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Although everything is paused, don’t hide in the dark",
      "kr_lyrics": "멈춰있지만 어둠에 숨지 마"
    },
    {
      "name": "Fly To My Room",
      "spotify": "https://open.spotify.com/track/1NHl9g36Ebu3g16y0vtUNV",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/a8f86aa9bb9aa5efe09f90866a9e98eb60170f98?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "This scenery that feels unfamiliar all of a sudden",
      "kr_lyrics": "갑자기 낯선 이 풍경"
    },
    {
      "name": "Blue & Grey",
      "spotify": "https://open.spotify.com/track/7Ki0hse0IfXEcXUlpyECbJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/b8b9f740e524d7bad8acb6c5644fafaf974e2580?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "After secretly collecting words that wander around in the void, now I fall asleep, at dawn, good night",
      "kr_lyrics": "허공에 떠도는 말을 몰래 주워 담고 나니, 이제 새벽잠이 드네 good night"
    },
    {
      "name": "Telepathy",
      "spotify": "https://open.spotify.com/track/6Fnvi5QnVkTskSzeRvvQds",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/48bea9a190001ae14178968d2f324bab8538812b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Meaningless worries, for a moment, lay them down, for a moment",
      "kr_lyrics": "괜한 걱정들은 잠시, 내려놓은 채로 잠시"
    },
    {
      "name": "Dis-ease",
      "spotify": "https://open.spotify.com/track/0hxeouHqP3qzpTHerA7ha2",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/f2c9fdc6239cbff949acbaffe7f097355651aa8c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Material things are a stun that my career gives me",
      "kr_lyrics": "물리적인 건 직업이 주는 stun!"
    },
    {
      "name": "Stay",
      "spotify": "https://open.spotify.com/track/0TdWVbcerMAcvljXrl9gpG",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/75f9c6c873d3c1876f5aa39663e7fb59bc06b4ee?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It’s just a few fragments of waves but I’ll have you changed",
      "kr_lyrics": "이건 몇 파동에 불과 하지만 내가 널 바꿔놓을 거야"
    },
    {
      "name": "Dynamite",
      "spotify": "https://open.spotify.com/track/5QDLhrAOJJdNAmCTJ8xMyW",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c07d5d2fdc02ae252fcd07e5",
      "audio": "https://p.scdn.co/mp3-preview/d8777ce6505aa52625472591ca898146bf3b0914?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Word up, talk the talk, just move like we off the wall",
      "kr_lyrics": ""
    },
    {
      "name": "Lights",
      "spotify": "https://open.spotify.com/track/3TDUktzfYXMWjkWqwoT5F1",
      "cover": "https://i.scdn.co/image/ab67616d00001e02da9c76ed020a7894443a3f97",
      "audio": "https://p.scdn.co/mp3-preview/089fba8a7d72b200abcbc5ee2dc853741aef1fbf?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I connect with you through sound, woah",
      "kr_lyrics": "君と音で繋がる woah"
    },
    {
      "name": "Your eyes tell",
      "spotify": "https://open.spotify.com/track/3TZ7NHkMT82AhwuYsd00Hz",
      "cover": "https://i.scdn.co/image/ab67616d00001e02da9c76ed020a7894443a3f97",
      "audio": "https://p.scdn.co/mp3-preview/494f6235f9e8c5fe34264cd7884748d2328146f8?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m looking straight ahead only at you so you don’t go anywhere",
      "kr_lyrics": "まっすぐに君だけを見て どこにも行かないように"
    },
    {
      "name": "OUTRO : The Journey",
      "spotify": "https://open.spotify.com/track/0VF357Gjay5vvCqWA1kSu6",
      "cover": "https://i.scdn.co/image/ab67616d00001e02da9c76ed020a7894443a3f97",
      "audio": "",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "Intro : Persona",
      "spotify": "https://open.spotify.com/track/7incJHhOl108CJBxylqc1z",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/5549a1b94670811519b70c33d8f40029d07a3e22?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Where’s your soul? Where’s your dream? Do you think you’re alive?",
      "kr_lyrics": ""
    },
    {
      "name": "Boy With Luv (Feat. Halsey)",
      "spotify": "https://open.spotify.com/track/7lrqvdivAYRGEiO8JFP31G",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/93add0cd36cfa7f830f38b1125d5e73c87a08b82?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A star that is called you, that made every trivial thing non-trivial",
      "kr_lyrics": "사소한 게 사소하지 않게 만들어버린 너라는 별"
    },
    {
      "name": "Make It Right",
      "spotify": "https://open.spotify.com/track/30YLyzfEjMQsXj4ZFslAmT",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/1d84fe05e1fa9a2cab27fc14074abaeb73966fd1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "In the eternal night for which I was unable to see the end, it was you who gifted me the morning",
      "kr_lyrics": "내게 아침을 선물한 건 너야 이제 그 손 내가 잡아도 될까"
    },
    {
      "name": "Jamais Vu",
      "spotify": "https://open.spotify.com/track/0PpNBEXkjalflGCMMsBV5B",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/66826149cbd868d461e4b78d457c6291c794159f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A sign that glimmers, “game over, over, over”",
      "kr_lyrics": "아른대는 Game over over over"
    },
    {
      "name": "Dionysus",
      "spotify": "https://open.spotify.com/track/5LvqzuJCNpi2pNkJAX8mBT",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/25b4f5cedd3edec85b88d7283e6ec6cea8ada6d6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Filling the studio, low voice, low voice, low voice. Bass drum goes like dum dum dum",
      "kr_lyrics": "Studio를 채운 저음 저음 저음 Bass drum goes like 덤덤덤"
    },
    {
      "name": "Interlude : Shadow",
      "spotify": "https://open.spotify.com/track/7om4LRoSct9hiMPo0fPn7m",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/fbe827a18610bcdd550432586280b549576c891a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The moment that I face myself at the lowest, it happens to be that I’m high up in the blue, cloudless sky",
      "kr_lyrics": "가장 밑바닥의 나를 마주하는 순간 공교롭게도 여긴 창공이잖아"
    },
    {
      "name": "Black Swan",
      "spotify": "https://open.spotify.com/track/2EmcTFQ1rM11wp2ztsXTHa",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/99b36846f15dc3d2363b439972695ce824f1221e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Even if harsh waves brush against me in the darkness, \nI will never get dragged away again, inside I saw myself myself",
      "kr_lyrics": "거센 파도 깜깜하게 나를 스쳐도 절대 끌려가지 않을 거야 다시 또 \ninside i saw myself myself"
    },
    {
      "name": "Filter",
      "spotify": "https://open.spotify.com/track/4bZZVcgWWMWPBwzTTp642w",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/9caca0432b210d82f44af5689196522b7119bc77?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I will become anything for you \nYou can pick and use one of me, yeah",
      "kr_lyrics": "뭐든 돼 줄게 날 골라 쓰면 돼 yeah"
    },
    {
      "name": "My Time",
      "spotify": "https://open.spotify.com/track/0YJFlxeHMUr9MxSDQVuQJA",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/2c36604ea1861acc61e29d88e066246a4a948cb5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "24, It feels as if I became an adult quicker than anyone",
      "kr_lyrics": "24 누구보다 더 빨리 어른이 된 것만 같아"
    },
    {
      "name": "Louder than bombs",
      "spotify": "https://open.spotify.com/track/4Aw8n6r2vuU0KUo1a2nftp",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/d1b8aacc50a1820d39150a9dd70052c4bbcf06e8?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "They are never a coincidence, yeah we picked this game",
      "kr_lyrics": "우연한 게 절대 아냐 yeah we picked this game"
    },
    {
      "name": "ON",
      "spotify": "https://open.spotify.com/track/0fZRNhPJ4AGmwY7rkpdbqK",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/c9253645569fc43d75fb416ddf096e8073e40375?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The shadow that grows by a step when I walk a step",
      "kr_lyrics": "한 발자국 떼면 한 발자국 커지는 shadow"
    },
    {
      "name": "UGH!",
      "spotify": "https://open.spotify.com/track/2QZe2H1f03t5PJWEMg2Mbe",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/4f05f68682b1a8385e66f6803ee2ba0b2ac62b7e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It's like no one can live without anger, \nthey get angry, angry, and angry",
      "kr_lyrics": ""
    },
    {
      "name": "00:00 (Zero O’Clock)",
      "spotify": "https://open.spotify.com/track/6fqaMyg066xlukvUJWdM2T",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/d2b337a19d32d4c3f2d5befd5beae1a71c76ca34?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The world holds its breath for a very brief moment",
      "kr_lyrics": "세상은 아주 잠깐 숨을 참아"
    },
    {
      "name": "Inner Child",
      "spotify": "https://open.spotify.com/track/25MHcbjvSdcfTiFgbKJiZF",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/873becf3ddc477a54847e00c37ac6fceb152e3f4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The child who was just smiling brightly looking at you like that",
      "kr_lyrics": "마냥 해맑게 웃던 아이 그런 널 보면"
    },
    {
      "name": "Friends",
      "spotify": "https://open.spotify.com/track/5RjUtRlDonw3TBgGGMLC5b",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/e5cdf4fa3dba56fa7947c0b9ed2460b636a519cd?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Like your pinky, we're still the same",
      "kr_lyrics": "네 새끼손가락처럼 우린 여전해"
    },
    {
      "name": "Moon",
      "spotify": "https://open.spotify.com/track/6KhAXXgDtEEahVzATvFNcn",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/ac8de4f2538fe8b3bfd71adbba8b00dce7763660?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I will orbit around you, I will stay by your side",
      "kr_lyrics": "네 주위를 맴돌게 네 곁에 있어 줄게"
    },
    {
      "name": "Respect",
      "spotify": "https://open.spotify.com/track/2yKBnKOmPXePrbHqRv42r4",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/ec2bbf05b35ee7605541f7dc4007ef8f1e8a65df?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Please don't say \"respect\" so easily, yeah",
      "kr_lyrics": "부디 존경을 쉽게 말하지 마 yeah"
    },
    {
      "name": "We are Bulletproof : the Eternal",
      "spotify": "https://open.spotify.com/track/133ocfbXXG4HTk76qgSeUb",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/9f5c6e2aaf76f78b81890aa46906d4ad703bd0a4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Throw stones at me, we're not afraid anymore",
      "kr_lyrics": "내게 돌을 던져 우린 겁이 없어 anymore"
    },
    {
      "name": "Outro : Ego",
      "spotify": "https://open.spotify.com/track/2LVw2bIK99go1NdD77dUCW",
      "cover": "https://i.scdn.co/image/ab67616d00001e02505190077497c230422f2934",
      "audio": "https://p.scdn.co/mp3-preview/79cd0727f5dba125a65567a30601787ec720dfff?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "One and only hope, one and only soul",
      "kr_lyrics": "하나뿐인 hope 하나뿐인 soul"
    },
    {
      "name": "Mikrokosmos",
      "spotify": "https://open.spotify.com/track/0jSccBRnhNU4KtACMQPvco",
      "cover": "https://i.scdn.co/image/ab67616d00001e0218d0ed4f969b376893f9a38f",
      "audio": "https://p.scdn.co/mp3-preview/94f64f836d7bc47e770b8869c3814fe691b0d6a1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We shine just for who we are, tonight",
      "kr_lyrics": "우리 그 자체로 빛나 tonight"
    },
    {
      "name": "HOME",
      "spotify": "https://open.spotify.com/track/6Yc3tjFCVR2bfAQFRTZBef",
      "cover": "https://i.scdn.co/image/ab67616d00001e0218d0ed4f969b376893f9a38f",
      "audio": "https://p.scdn.co/mp3-preview/cdb595939e53669b62e9431ea066d423b8262b22?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "As long as I have you, anywhere will become my home",
      "kr_lyrics": "너만 있다면 다 내 집이 될 거야"
    },
    {
      "name": "Euphoria",
      "spotify": "https://open.spotify.com/track/5YMXGBD6vcYP7IolemyLtK",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/ac5cd7928e79541a123741c8a08eeffa9f342e59?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Please don’t let ever go of the hand you’re holding",
      "kr_lyrics": "잡은 손 절대 놓지 말아줘"
    },
    {
      "name": "Trivia 起 : Just Dance",
      "spotify": "https://open.spotify.com/track/4YDHRtzm0OGuieCTVQjVuk",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/734d0b3f0592960dc14fa20f9e9d7e30710f719f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I like the dances we do together, with you",
      "kr_lyrics": "함께 하는 춤들이 좋아, 너와"
    },
    {
      "name": "Trivia 承 : Love",
      "spotify": "https://open.spotify.com/track/6bSwpQYEguyMlkCoWiBt3Y",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/f56a8af7012a075e4f66be30b114e785df95c977?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "My love, love, love \nwhen we gently sit on it, it becomes a heart",
      "kr_lyrics": "내 사랑, 사랑, 사랑 \n그 위에 살짝 앉음 하트가 돼"
    },
    {
      "name": "Trivia 轉 : Seesaw",
      "spotify": "https://open.spotify.com/track/0mZI1NpihIVcho2f9MmqSW",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/733a7136656c6bcc10014497bd8eea6d850a2c5a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "End up becoming exhausted, \nironically reaching the paralleled balance",
      "kr_lyrics": "지칠 만큼 지쳐서 되려 평행이 됐네"
    },
    {
      "name": "Epiphany",
      "spotify": "https://open.spotify.com/track/6L88EH68XwlaXwvChlTS41",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/2083bf264066339c09a6a97541ccc9fec2bff33f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Though I’m not perfect, I’m so beautiful",
      "kr_lyrics": "좀 부족해도 너무 아름다운 걸"
    },
    {
      "name": "I'm Fine",
      "spotify": "https://open.spotify.com/track/7HYJqAMbKDJYRyEfUGOCBB",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/659385db5221ce38ee1b01e6ca23bc18e01ab290?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m not lonely– it’s okay, it’s okay",
      "kr_lyrics": "외롭지 않은 걸 괜찮아 괜찮아"
    },
    {
      "name": "IDOL",
      "spotify": "https://open.spotify.com/track/1e8J3XClxZbFmvIHLI8CE4",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/7d36848696b275c92e3baa2cbc70adb1e0ecf05c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Sometimes I become a superhero\n Keep spinning, your Anpanman",
      "kr_lyrics": "때론 슈퍼히어로가 돼 돌려대 너의 Anpanman"
    },
    {
      "name": "Answer : Love Myself",
      "spotify": "https://open.spotify.com/track/2X3UgVLSA4wYriGIQyYmMA",
      "cover": "https://i.scdn.co/image/ab67616d00001e023825e6d4d02e4b4c0cec7e1d",
      "audio": "https://p.scdn.co/mp3-preview/cb58b07e7a2bd7f59eaa431b1de8907f41237ce6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Yesterday’s me, today’s me, tomorrow’s me",
      "kr_lyrics": "어제의 나 오늘의 나 내일의 나"
    },
    {
      "name": "Intro: Singularity",
      "spotify": "https://open.spotify.com/track/5rNZsITjXf23iFkRA924FV",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/59659bb8aba27231bf3a1530ad9592b8e8c872f9?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Tell me, if my voice is fake",
      "kr_lyrics": "Tell me 내 목소리가 가짜라면"
    },
    {
      "name": "FAKE LOVE",
      "spotify": "https://open.spotify.com/track/6m1TWFMeon7ai9XLOzdbiR",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/ba2f6a0afc23bf9f804c233d3e587009e52a14c2?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I could pretend I was happy even if I was sad",
      "kr_lyrics": "슬퍼도 기쁜 척 할 수가 있었어"
    },
    {
      "name": "The Truth Untold (feat. Steve Aoki)",
      "spotify": "https://open.spotify.com/track/7DEKa5Z7Cl8s3Y7imb88OM",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/893cee7ac1b37e0d102320c82052fdff01b09dd4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A flower that looks like you bloomed in the garden of loneliness",
      "kr_lyrics": "외로움의 정원에 핀 너를 닮은 꽃"
    },
    {
      "name": 134340,
      "spotify": "https://open.spotify.com/track/1MX0g22bQkr9HDVe37fLnN",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/ba1acaaefdbc91573e6ef6f3a9644b8c0f938d76?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Without a name to myself, I still orbit you",
      "kr_lyrics": "어떤 이름도 없이 여전히 널 맴도네"
    },
    {
      "name": "Paradise",
      "spotify": "https://open.spotify.com/track/1YO4xJXhh9A1Feg9k8xuy2",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/542ae410d05c22f6a75f84fb20c6ea856f190aac?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We deserve a life, whether it's big or small, you're stiil just you",
      "kr_lyrics": "We deserve a life 뭐가 크건 작건 그냥 너는 너잖어"
    },
    {
      "name": "Love Maze",
      "spotify": "https://open.spotify.com/track/4ROdFnoZNn2RTmwct0cVpx",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/6c4205f4fa495856cedbe8a4ba3d01d89d5f58a4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "In the darkness, as long as there are us, it's enough",
      "kr_lyrics": "어둠 속에선 우리면 충분해"
    },
    {
      "name": "Magic Shop",
      "spotify": "https://open.spotify.com/track/5MTGPkmiUuud9NkA0sl2nI",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/8a84d3b9d5252ed45c87a3b865926c2537ac6cc6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Once you open the door and enter, this place will wait for you",
      "kr_lyrics": "그 문을 열고 들어가면 이 곳이 기다릴 거야"
    },
    {
      "name": "Airplane pt.2",
      "spotify": "https://open.spotify.com/track/4lAE47gj539h8R1yxPhhGG",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/20a977a5d9f2f71b1de174c7890c247a29e74630?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "My passport is about to die from over work",
      "kr_lyrics": "여권은 과로사 직전"
    },
    {
      "name": "Anpanman",
      "spotify": "https://open.spotify.com/track/34OSqW5ULWxmCEMjJ1ZgVW",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/8d213a599d989ed14686a9051cb406e725b32d75?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "My ideal is a really cool hero",
      "kr_lyrics": "되게 멋진 영웅이 내 낭만"
    },
    {
      "name": "So What",
      "spotify": "https://open.spotify.com/track/0wqqe8k13bJPxRt7FEmnwS",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/d2ac125318a419e49b05dbbf5066571c69f04948?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Don't stop and worry yourself, it's good for nothing",
      "kr_lyrics": "멈춰서 고민 하지마, 다 쓸데 없어"
    },
    {
      "name": "Outro: Tear",
      "spotify": "https://open.spotify.com/track/27yKZtF7WLdmlLoW8qMssq",
      "cover": "https://i.scdn.co/image/ab67616d00001e028fbcf6544ff02a8959a81781",
      "audio": "https://p.scdn.co/mp3-preview/5053445e4a36a115e8ab02fceafac1a3c0ba1a73?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "But now, the beer tastes only bitter",
      "kr_lyrics": "하지만 이제 쓰기만 한 beer"
    },
    {
      "name": "Don't Leave Me",
      "spotify": "https://open.spotify.com/track/3zIG0WuI5RoJsFYnErkFDU",
      "cover": "https://i.scdn.co/image/ab67616d00001e027df155730d4d753560ec28a5",
      "audio": "https://p.scdn.co/mp3-preview/22e45e8edc434187a280755977b21def2d8d42cb?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Crossing paths without meeting, all of it destiny",
      "kr_lyrics": "すれ違いall of it destiny"
    },
    {
      "name": "Crystal Snow",
      "spotify": "https://open.spotify.com/track/6NbfFVZ01Ttvvqmcok8DxL",
      "cover": "https://i.scdn.co/image/ab67616d00001e027df155730d4d753560ec28a5",
      "audio": "https://p.scdn.co/mp3-preview/d9809f15f82da2ee2c971b9a3b89521ca60016a5?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "This genuine warmth, please last forever",
      "kr_lyrics": "確かな 温もりよ 永遠に続け"
    },
    {
      "name": "Let Go",
      "spotify": "https://open.spotify.com/track/1OqDvYVDhJyFZny7XlfIyZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e027df155730d4d753560ec28a5",
      "audio": "https://p.scdn.co/mp3-preview/c65811b3c4b98c91310fc3962c9e358e16d2e6b5?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Living without you is already unbelievable",
      "kr_lyrics": "君がいない生活はもう、unbelievable"
    },
    {
      "name": "Intro: Serendipity",
      "spotify": "https://open.spotify.com/track/61RvEx7GLYRHQhG7ldjJo1",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/5d2d565db342e119428462afdb81cdf7eba2d2d1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I'm your calico cat",
      "kr_lyrics": "난 네 삼색 고양이"
    },
    {
      "name": "DNA",
      "spotify": "https://open.spotify.com/track/3uRLwBjI2TahxslcMTvpFs",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/14ca714b1b53383f66390275030264c57b55750d?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Because all of this is not a coincidence",
      "kr_lyrics": "이 모든 건 우연이 아니니까"
    },
    {
      "name": "Best Of Me",
      "spotify": "https://open.spotify.com/track/5C6A1WXVfKvBBQmaFFnBgs",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/1907e599d246330b93d498b75ef445223f0a0cbb?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Day by day, summer and winter",
      "kr_lyrics": "하루하루, 여름, 겨울"
    },
    {
      "name": "dimple",
      "spotify": "https://open.spotify.com/track/6pp6xf9zS55GD4nr318XUH",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/72ead820d1952c3f8046aa04d4005e0bc4069b9b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I want to drown in them to death, I want to sink in them to death",
      "kr_lyrics": "빠져 죽고 싶어 잠겨 죽고 싶어"
    },
    {
      "name": "Pied Piper",
      "spotify": "https://open.spotify.com/track/1ZPeaPDjQOOC8hw1mNjyjF",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/7133c674178a481df030fdd854b97b554e6b8ae3?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Even if you try to resist, you won’t be able to help it",
      "kr_lyrics": "발버둥쳐봐도 더는 소용없을 걸"
    },
    {
      "name": "MIC Drop",
      "spotify": "https://open.spotify.com/track/4gZGAVECoiutzp64KSHNjE",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/f1c295a6dfb1977988e4008e3379f099087a6fb2?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Haters are already terrified",
      "kr_lyrics": "Hater들은 벌써 학을 떼"
    },
    {
      "name": "Go Go",
      "spotify": "https://open.spotify.com/track/5vOT8VO87TAnUjh0oADwb1",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/c6af5853f597858f51f598da1f036784df0f25a5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If you keep saving in fear, it becomes a shit",
      "kr_lyrics": "쫄면서 아끼다간 똥이 돼버려"
    },
    {
      "name": "Outro: Her",
      "spotify": "https://open.spotify.com/track/559U79ujLJSP6OUyH2nGLl",
      "cover": "https://i.scdn.co/image/ab67616d00001e02829305487c8f3b96a1d955b3",
      "audio": "https://p.scdn.co/mp3-preview/ebec586aa30f57e414a163e270bc4c23bab2e980?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I learned that even after the darkness is over you’re the morning to me",
      "kr_lyrics": "난 알았어 어둠이 끝나도 내겐 넌 아침이란 걸"
    },
    {
      "name": "Spring Day",
      "spotify": "https://open.spotify.com/track/2j1fFjWHCI9KJSwcuYAOyF",
      "cover": "https://i.scdn.co/image/ab67616d00001e021fd0a8fc28b2a0a5d9cdc6c6",
      "audio": "https://p.scdn.co/mp3-preview/c8c08f664e5dcedb8eaa146baea425cc095b7782?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "This winter is also coming to its end",
      "kr_lyrics": "이 겨울도 끝이 나요"
    },
    {
      "name": "Not Today",
      "spotify": "https://open.spotify.com/track/3wyrhwPpV8uhMMEms4vG3X",
      "cover": "https://i.scdn.co/image/ab67616d00001e021fd0a8fc28b2a0a5d9cdc6c6",
      "audio": "https://p.scdn.co/mp3-preview/e153de9376de206a788a16c91b264d85528f8f79?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Ready! Aim! Fire!",
      "kr_lyrics": "겨눠 총! 조준! 발사!"
    },
    {
      "name": "Outro: Wings",
      "spotify": "https://open.spotify.com/track/7kyUapJyppdjzoAWB6XS14",
      "cover": "https://i.scdn.co/image/ab67616d00001e021fd0a8fc28b2a0a5d9cdc6c6",
      "audio": "https://p.scdn.co/mp3-preview/0b240eb2130ec31526b71893004211de93ff92a2?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I fly through the air that gets heavier and heavier",
      "kr_lyrics": "점점 무거워지는 공기를 뚫고 날아"
    },
    {
      "name": "A Supplementary Story: You Never Walk Alone",
      "spotify": "https://open.spotify.com/track/2ZbYyDM0pacTwP2odNsdlo",
      "cover": "https://i.scdn.co/image/ab67616d00001e021fd0a8fc28b2a0a5d9cdc6c6",
      "audio": "https://p.scdn.co/mp3-preview/3b1383e0a49fb5a1dd11b7766d3a888e178773e0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "From your hand that I’m holding, I can feel your warmth",
      "kr_lyrics": "잡은 너의 손 너의 온기가 느껴져"
    },
    {
      "name": "Intro: Boy Meets Evil",
      "spotify": "https://open.spotify.com/track/1hlT8F0X27uf3fpOWawjbY",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/08e8424ca38496de08f6051cc3b87738f1058f2e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The future abandoned by me, drunk in love",
      "kr_lyrics": "연애에 취해서 버려진 미래"
    },
    {
      "name": "Blood Sweat & Tears",
      "spotify": "https://open.spotify.com/track/2u54HNQamwFuOMLSuhSRom",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/858ccff53f9d75ab7596620effea46aded9e30d8?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I drank from the poisoned chalice, knowing it was poisoned",
      "kr_lyrics": "알면서도 삼켜버린 독이 든 성배"
    },
    {
      "name": "Begin",
      "spotify": "https://open.spotify.com/track/0bGJHUPR6ems9tzIljlPFR",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/9fc6919cbb1af7b0803c1792ac47ac418ce7740c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I feel like dying when my brother is sad",
      "kr_lyrics": "죽을 것 같아 형이 슬프면"
    },
    {
      "name": "Lie",
      "spotify": "https://open.spotify.com/track/1nWB8isqs2tviWk20G5pow",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/c5378ea527951d75db50c2592725929d4a80da9c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Please take me out of this hell",
      "kr_lyrics": "이 지옥에서 날 꺼내줘"
    },
    {
      "name": "Stigma",
      "spotify": "https://open.spotify.com/track/3LTwMQ9kkn5VVhP3jipBlR",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/ccaad8641876cb4e900e34c124d59149db378690?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Deeper, every day, only the heart gets more hurt",
      "kr_lyrics": "더 깊이 매일이 가슴만 아파져"
    },
    {
      "name": "First Love",
      "spotify": "https://open.spotify.com/track/1UeVC9gDeHxwlWOQyQJerj",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/53d7fd18fc0a6bd501a6c65b3443699176abc624?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The image of you being abandoned with dust piling on your once-shiny keys",
      "kr_lyrics": "백옥 같던 건반 그 위 먼지가 쌓여가며 방치됐던 니 모습"
    },
    {
      "name": "Reflection",
      "spotify": "https://open.spotify.com/track/6O7358UPKsUumzjumFxVtp",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/b0e22ea7194946961c9e9c41106ca9247bdd4c09?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "In the darkness, people look happier than during the day",
      "kr_lyrics": "어둠 속에서 사람들은 낮보다 행복해 보이네"
    },
    {
      "name": "MAMA",
      "spotify": "https://open.spotify.com/track/51hIGgLnT8s6gEzjVqKlEF",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/d077d2316ec8181bc3b9355d0a8f988ed9c265c7?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Because you gave me all you got, because you were my support",
      "kr_lyrics": "내게 아낌없이 주셨기에 버팀목이었기에"
    },
    {
      "name": "Awake",
      "spotify": "https://open.spotify.com/track/3gxNkvcP8scSzL6mGznTn3",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/5fe92a0a07e39a4876d04a15bbc3265b951b9f79?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m just walking and walking in this darkness",
      "kr_lyrics": "이 어둠 속을 그냥 걷고 또 걷고 있어"
    },
    {
      "name": "Lost",
      "spotify": "https://open.spotify.com/track/2So2zLatKtnIP0cy3a4Fn0",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/d9631a8b490a5945fcfcb544210b99931f4146a1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "however many times I wander, I will still believe in my way",
      "kr_lyrics": "수없이 헤매도 난 나의 길을 믿어볼래"
    },
    {
      "name": "BTS Cypher 4",
      "spotify": "https://open.spotify.com/track/4cTSnpyaIR1qGaTOLJunDM",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/7f9828f307c6603633b736aeefd330e6a56db42e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Though you hate me, you know me",
      "kr_lyrics": "니가 날 싫어해도 you know me"
    },
    {
      "name": "Am I Wrong",
      "spotify": "https://open.spotify.com/track/7BFVLQASwcGrxEPsz1teIW",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/9d6297deb56224dd0f90557718e72b36aa363b1d?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We all are dogs and pigs, we get angry and become dogs",
      "kr_lyrics": ""
    },
    {
      "name": "21st Century Girl",
      "spotify": "https://open.spotify.com/track/52d5NT69mkmr6WzvQJ9vHr",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/18a3b2604597d05229381d5c9d6026c8d2bb9110?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "“Oh yeah, who’s that girl? Who is she?”",
      "kr_lyrics": "“Oh yeah 쟤 뭐야 대체 누구야?”"
    },
    {
      "name": "2! 3!",
      "spotify": "https://open.spotify.com/track/3KVOfGrYVjoP1w8T2HVltm",
      "cover": "https://i.scdn.co/image/ab67616d00001e028bd5d941f9ced8e7f9c60dd4",
      "audio": "https://p.scdn.co/mp3-preview/d62490c19c6574622d6b108f0c7b1d100d8daf05?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "(So thanks) for believing in someone like me",
      "kr_lyrics": "(So thanks) 이런 날 믿어줘서"
    },
    {
      "name": "Good Day",
      "spotify": "https://open.spotify.com/track/2aTDPjGFdyBfc3lKLAAaoI",
      "cover": "https://i.scdn.co/image/ab67616d00001e029db43b5fb2b278d7f70a6cf9",
      "audio": "https://p.scdn.co/mp3-preview/55997d632db68169a1d219befa38808074c362b5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’ll be by your side, we’ll be okay",
      "kr_lyrics": "そばにいるって We’ll be okay"
    },
    {
      "name": "Wishing On A Star",
      "spotify": "https://open.spotify.com/track/3UvbL9zd4XTsCL8O6Qp2bR",
      "cover": "https://i.scdn.co/image/ab67616d00001e029db43b5fb2b278d7f70a6cf9",
      "audio": "https://p.scdn.co/mp3-preview/eeee2b5e968fd001218b7e261f9ef4467f8ad7a2?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "So my baby, even if Pandora lies ahead, there’s hope",
      "kr_lyrics": "進めるはずさだから my baby"
    },
    {
      "name": "For You",
      "spotify": "https://open.spotify.com/track/2offgVA6h500KKIvUYU5kP",
      "cover": "https://i.scdn.co/image/ab67616d00001e029db43b5fb2b278d7f70a6cf9",
      "audio": "https://p.scdn.co/mp3-preview/67960a64c083e197d81453b97ba055986cc3e717?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "Intro: The Most Beautiful Moment in Life",
      "spotify": "https://open.spotify.com/track/2C4AmTAKoJQgfMDXFasXcY",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/9527c539b2b4239d1e25f9becd2ae3dd69f2820e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I ask myself once again, “are you happy now?”, The answer is already set, “I’m happy”",
      "kr_lyrics": "다시 나에게 되물어봐 지금 행복한가"
    },
    {
      "name": "I Need U",
      "spotify": "https://open.spotify.com/track/6EWoLZ6n26bF3Cl9Hq3pqv",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/f9d5a0385bfb28066bc80848ed8ef3a68c81bcaf?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It goes round & round Why do I keep coming back. I go down & down At this point, it must be that I’m a fool",
      "kr_lyrics": "It goes round & round 나 왜 자꾸 돌아오지. I go down & down 이쯤 되면 내가 바보지"
    },
    {
      "name": "Hold Me Tight",
      "spotify": "https://open.spotify.com/track/7gnIQ7K1TBbIvhVrR4c4gI",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/72620ae737fc544ab21deeb57ea589efbe408307?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Everything feels cold and even the clear sky feels dark",
      "kr_lyrics": "다 모든 게 차갑고 저 맑은 하늘도 다 어두워"
    },
    {
      "name": "Autumn Leaves",
      "spotify": "https://open.spotify.com/track/0S6rA2IKknGGsyZNEkwRJB",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/9b4f45ed493caf2ca6519716a08ee7cde4bbcf1e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "One dry leaf hanging on the branch is breaking, I can see the thing called \"the end",
      "kr_lyrics": "가지 위에 달린 낙엽 한 장 부서지네 끝이란 게 보여,"
    },
    {
      "name": "Run",
      "spotify": "https://open.spotify.com/track/0RElgFnZjIZ0hLlO4WY14R",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/8790e7b078f3717aebcb3f45712ce4054fb4db1a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Like chasing a butterfly, life wandering in a dream, I follow your traces",
      "kr_lyrics": "마치 나비를 쫓듯 꿈 속을 헤매듯 너의 흔적을 따라가"
    },
    {
      "name": "Ma City",
      "spotify": "https://open.spotify.com/track/612T32kWgsXgsJ5gl8KXpN",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/e9277cfbf2b8a96641b450927354204bf4dc5c0b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I like Lake Park more than Han River, Though it’s small, it embraces me much more warmly",
      "kr_lyrics": "한강보다 호수공원이 더 좋아 난 작아도 훨씬 포근히 안아준다고 널"
    },
    {
      "name": "Silver Spoon",
      "spotify": "https://open.spotify.com/track/5PRJlVG1c2JNa85mFoGARM",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/7f0eff0d47c7fa67873b2c206b7ff89fffb282be?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Ah stop talking about effort, more effort. Ah it makes me cringe",
      "kr_lyrics": "아 노력노력 타령 좀 그만둬 아 오그라들어 내 두 손발도"
    },
    {
      "name": "Dope",
      "spotify": "https://open.spotify.com/track/4o3Ao6wY5fbJR32fQKabfQ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/7a827214e5da49e758fcfed8d810267daa2c504b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I reject rejection. I’m too cool from the beginning. Everyone copies me",
      "kr_lyrics": "거부는 거부해 / 난 원래 너무해 / 모두 다 따라 해"
    },
    {
      "name": "Burning Up (Fire)",
      "spotify": "https://open.spotify.com/track/0aE3V0zgSD2YwkEHW42gxG",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/6331f6210b71a3c42b6b4dabfe5be82202e6b8f5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Live as you like, your life is yours anyway",
      "kr_lyrics": "니 멋대로 살어 어차피 니 꺼야"
    },
    {
      "name": "Save Me",
      "spotify": "https://open.spotify.com/track/7bxGcILuAjkZzaveU28ZJS",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/ea67401270adf2ba26f55ce7b9f8e8ef6f16e402?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The moon shines brighter today, the empty space in my memory. The lunatic that swallowed me, please save me tonight",
      "kr_lyrics": "오늘따라 달이 빛나 내 기억 속의 빈칸 / 날 삼켜버린 이 lunatic, please save me tonight"
    },
    {
      "name": "Epilogue: Young Forever",
      "spotify": "https://open.spotify.com/track/6BskTMfDjXVzeqQHOau5Vi",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/d1ccf1fa327499de4e40e95e8ce91c2730207a2e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The huge applause can’t be mine forever",
      "kr_lyrics": "언제까지 내 것일 순 없어 큰 박수갈채가"
    },
    {
      "name": "Converse High",
      "spotify": "https://open.spotify.com/track/4XtvJ78i5yI5QigVHuxWZt",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/0d85fa2de18643e364da5bceaa11df7e828e5a79?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "You can buy two pairs with just 100,000 won, you know what I want",
      "kr_lyrics": "10만원이면 두 켤레를 사 넌 내가 원하는 걸 알지"
    },
    {
      "name": "Moving On",
      "spotify": "https://open.spotify.com/track/7j8YcE2SKZoLkeLL0qMvkH",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/0a22baac40a5f9ed9ed68198117c88772768e46c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We cried a lot, we laughed a lot, but it all was pretty beautiful. Nonhyeondong 3rd floor, thank you",
      "kr_lyrics": "울기도 웃기도 많이 했지만 모두 꽤나 아름다웠어 / 논현동 3층, 고마웠어"
    },
    {
      "name": "Whalien 52",
      "spotify": "https://open.spotify.com/track/2HMVg8AqrijDGKu0U5bVNH",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/b0989eef725c72f2e8a2d7a61143a732fdb4c185?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Today as well, I sing, yet again",
      "kr_lyrics": "오늘도 다시 노래하지 나"
    },
    {
      "name": "Butterfly",
      "spotify": "https://open.spotify.com/track/2QP1vvLPtAVOVAFabpqypA",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/9f3cbb29e6322c8f8415e57835d0cc1b55d90ca5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If I touch you, that you might fly away, that you might be shattered",
      "kr_lyrics": "손 대면 날아갈까 부서질까"
    },
    {
      "name": "House of Cards - Full Length Edition",
      "spotify": "https://open.spotify.com/track/6S2gYweMmT6xygVh5q3QLa",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/ca3e3017732b68f0c65bdef2c8fb079708e70baa?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "No way, no way it’s collapsing again ah",
      "kr_lyrics": "No way, no way 또 무너지는 걸 ah"
    },
    {
      "name": "Love Is Not Over - Full Length Edition",
      "spotify": "https://open.spotify.com/track/12MGUs7yIus6sU09ekZMjw",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c6dbc63cf145b4ff6bee3322",
      "audio": "https://p.scdn.co/mp3-preview/cde77fc22f800ac2e6f097cccb30c4db26d52d35?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Love is pain after pain yeah",
      "kr_lyrics": "사랑이란 아프고 아픈 것 yeah"
    },
    {
      "name": "Intro: Never Mind",
      "spotify": "https://open.spotify.com/track/6JbPyMiLnWaaKusic64bCq",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a5e9b18ada0905fa82cd4756",
      "audio": "https://p.scdn.co/mp3-preview/023d2bc927bbc85975ef96723d0aa0cf5ff76270?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The moment when the music flows, I feel like I’ll go crazy hey",
      "kr_lyrics": "음악이 흐르는 순간 난 미쳐버릴 것 같아 hey"
    },
    {
      "name": "Boyz with Fun",
      "spotify": "https://open.spotify.com/track/1sz4drpDPpHVrPUgnXGaNn",
      "cover": "https://i.scdn.co/image/ab67616d00001e021504edb7a9a5e4e64547fb94",
      "audio": "https://p.scdn.co/mp3-preview/73df286944680c126e028117cc5d0c814101ae95?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "They told me I’d make my whole family go broke if I acted like some musician",
      "kr_lyrics": "음악 한답시고 깝치면 집안 거덜내니까"
    },
    {
      "name": "Intro.",
      "spotify": "https://open.spotify.com/track/3H3i1F0msbZ30iZMYaQ4rN",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/b8fc6ed5910ae93ef07b1343771502105b0c9afb?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "The Stars",
      "spotify": "https://open.spotify.com/track/1PfGlo5nWnbBxfQyY2rxYk",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/f2cf5f920b7da91aaf2780088a3b3d6e5b750cac?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Can you feel this life? If so, don’t give up",
      "kr_lyrics": "Can you feel this life？ なら、諦めんなよ"
    },
    {
      "name": "Iine!",
      "spotify": "https://open.spotify.com/track/5lMu1penXwmhLWp82YwTpa",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/aef2fd135683212a27002575094aa2cfbf13ec11?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "After we broke up you still look so bright, you're pretty woman",
      "kr_lyrics": "離れてから君は look so bright, you're pretty woman"
    },
    {
      "name": "Iine!Pt.2 - Ano Bashode -",
      "spotify": "https://open.spotify.com/track/5ajpyr32JgFtvW0nzvgva4",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/eee9967e13672acf551fb92a63f800eeec7f0866?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "At that place, if we can meet",
      "kr_lyrics": "あの場所で 会えるならば"
    },
    {
      "name": "Wake Up",
      "spotify": "https://open.spotify.com/track/7gLRRcl3qKKpDlt0gApSAJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/52e9e8d9e593dd6fe724a3934763beb0ef1becfa?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The time is passing by but the thrill",
      "kr_lyrics": "時間は過ぎて行くけど thrill"
    },
    {
      "name": "Outro.",
      "spotify": "https://open.spotify.com/track/0KFNlFyyYU3i4JRhNR0V14",
      "cover": "https://i.scdn.co/image/ab67616d00001e021bfda04c5a3714b6225e4ddc",
      "audio": "https://p.scdn.co/mp3-preview/1a7a71bc765730cf59121215b6db6fde28311ef5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "Intro: What Am I to You",
      "spotify": "https://open.spotify.com/track/3HhgGvmDKx13uRTkXYfcDw",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/813550cc61e32b4edbdb59a8023a1e3e066f2149?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "You’re a goalie without determination. And I’m Messi running across the empty field.",
      "kr_lyrics": "넌 의지를 잃은 키퍼 / 난 허허벌판을 달리는 메시지"
    },
    {
      "name": "Danger",
      "spotify": "https://open.spotify.com/track/0zzRxtfO5FGxKdqq4OKmlw",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/41ccef87df09b2b2da2994604faebcea4e0843da?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We’re parallel lines, looking at the same spot but so different",
      "kr_lyrics": "우린 평행선, 같은 곳을 보지만 너무 다르지"
    },
    {
      "name": "War of Hormone",
      "spotify": "https://open.spotify.com/track/29SjtKzBoJDgyIBusHylIS",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/2b84530b796f2827d05466b60bc4c54cac89b9b6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Women are the best gift, gift",
      "kr_lyrics": "여자는 최고의 선물이야 선물이야"
    },
    {
      "name": "Hip Hop Phile",
      "spotify": "https://open.spotify.com/track/4c9XojqJDu7KNCh8GmNbj5",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/9a46bbeb4e33243a45d33ab4ee3d55955d91d2f4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I had so much to say that the stories told by others were not enough",
      "kr_lyrics": "할 말이 많아서 남들이 해주는 이야기론 부족하다 느꼈지"
    },
    {
      "name": "Let Me Know",
      "spotify": "https://open.spotify.com/track/2uqzfXB7NlBnhQd04W7HaH",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/65a068f32130ce81ceb4f0cbdd4fc7ac0373ea4a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "You take away the stars of my night, you take away the sun of my day",
      "kr_lyrics": "지금 넌 나의 밤의 별을 가져가, 낮의 해를 가져가"
    },
    {
      "name": "Rain",
      "spotify": "https://open.spotify.com/track/6Jr2GutTFyfvAzGA36R2Uj",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/460515306539153ea2d25d31649b24ee8b8257dd?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A gray building in a gray city, the gray rain on a gray road",
      "kr_lyrics": "회색 시의 회색 빌딩, 회색 길 위의 회색 비"
    },
    {
      "name": "BTS Cypher Pt.3: Killer",
      "spotify": "https://open.spotify.com/track/5OlieB5VdsOMuBuCtllXGW",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/e476e3a8574b532f6fccbed612898755fc43d032?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I live a hundred times harder than those bastards who do hip hop with their keyboards",
      "kr_lyrics": "키보드로 힙합 하는 놈들보다 백 배는 열심히 살지"
    },
    {
      "name": "Could You Turn off Your Cell Phone",
      "spotify": "https://open.spotify.com/track/022wInIMcMtWRqkcpy7WwO",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/65c054c39b67f80a3546a27b1afda66cb0e14e7d?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Of course, you’re busy updating Facebook or Twitter again",
      "kr_lyrics": "또 업뎃하기 바쁘겠지 얼굴책 아님 짹짹이에"
    },
    {
      "name": "Embarrassed",
      "spotify": "https://open.spotify.com/track/3eSPLTR9JtKiT1X4sAkTg8",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/b791e053b64e286c8af4a456c6243eef29bf1e9d?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "But my arrow keeps missing the target that is you",
      "kr_lyrics": "근데 내 화살은 너란 과녁을 자꾸 피해가기만 해"
    },
    {
      "name": "24/7=Heaven",
      "spotify": "https://open.spotify.com/track/17SBD4aDKo9ZeahcQJ6j72",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/2ef4978668ac6f4d04ff2b5097d1ad9c8de3b375?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The Sunday when I’ll be meeting you, the Sunday that I’ve been waiting for",
      "kr_lyrics": "너를 만나는 Sunday 기다려왔던 Sunday"
    },
    {
      "name": "Look Here",
      "spotify": "https://open.spotify.com/track/0x4cMbCLC6L7aJQs3EiPaZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/50d26616d94b06e7ef20a1ef5a228a4db5cb5cae?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Love your Alexander Wang, love your Isabel Marant",
      "kr_lyrics": "Love your 알렉산더 왕 love your 이자벨 마랑"
    },
    {
      "name": "2nd Grade",
      "spotify": "https://open.spotify.com/track/5EdwOTiD4Vz7xEoB7jt8En",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/218d6fff98335513b932e60197532d7cdbe47b85?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m still 181cm, baby, it’s only the height of my mind that grew",
      "kr_lyrics": "아직 181 baby 마음의 키만 컸으"
    },
    {
      "name": "Outro: Do You Think It Makes Sense?",
      "spotify": "https://open.spotify.com/track/0I4CicY6MftmDgdd76LXss",
      "cover": "https://i.scdn.co/image/ab67616d00001e02abe7090bc3ae94d741dfaf6b",
      "audio": "https://p.scdn.co/mp3-preview/00aa75e3ef77b0d7e7471abe084d4c342e957c0c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Love is not over, it doesn’t make sense, Story is not over, it doesn’t make sense",
      "kr_lyrics": ""
    },
    {
      "name": "Miss Right",
      "spotify": "https://open.spotify.com/track/1ht2uYq91yLc9S6IxwiwCK",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/da3147c79b77f6a83fb9600a07ae960603770744?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "That person who I thought would exist only exist in novels is you",
      "kr_lyrics": "소설 속에서나 있을 것만 같던 그 사람 바로 너야"
    },
    {
      "name": "Intro: Skool Luv Affair",
      "spotify": "https://open.spotify.com/track/5heidJi9Gni0QHhXStoimY",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/92e27e50992c157489f0ca9db465f84b89b94f1f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "As long as I have you, I have everything, like a millionaire",
      "kr_lyrics": "너만 있으면 뭐든 다 가졌지 like a milli"
    },
    {
      "name": "Boy in Luv",
      "spotify": "https://open.spotify.com/track/1wdWWC1YzKkCWp06e0IPqH",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/4fc3cb0426bed70ec502d5587f3c4f001826e912?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A bad bad girl on the outside\nAn even more bad bad girl on the side\nIf you lose a guy like me, you'll regret it",
      "kr_lyrics": "겉으론 bad bad girl, 속은 더 bad, bad girl\n나 같은 남잘 놓치면 후회하게 될 걸\n메신저 확인해놓고 누르지 않는 너의 행위"
    },
    {
      "name": "Where You From",
      "spotify": "https://open.spotify.com/track/6gGCS5r2t5uxaeBWAPeBp2",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/980158403e554cfe674feb21e5d435789e6e9d60?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "Just One Day",
      "spotify": "https://open.spotify.com/track/5oXLcjfVfq0QxIfgIHgYGn",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/6057beede87a02dfadd9d571da5411ee1cd6de71?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "My handbag is your waist\nYo ma honey\nWhenever I see you I run out of breath like the streets of Myungdong",
      "kr_lyrics": "서로 같이 어딜 가든 내 핸드백은 니 허리\nYo ma honey\n볼 때마다 숨이 막혀 명동 거리처럼"
    },
    {
      "name": "Tomorrow",
      "spotify": "https://open.spotify.com/track/1LdpcTZm0Of4Nq0FsbREKO",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/28a7c0aeddbcc6a632d9d397021236b34a04c2ab?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Same day, same moon\n24/7 every moment repeats\nMy life is in between",
      "kr_lyrics": "같은 날, 같은 달, 같은 날, 같은 달\n24/7 매번 반복되는 매 순간, 매 순간\n어중간, 어중간한 내 삶"
    },
    {
      "name": "BTS Cypher Pt.2: Triptych",
      "spotify": "https://open.spotify.com/track/1EzaBJk1rcT3ukKRPko1s4",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/d33036118eb2e549209234351e102bdec6420565?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "All you hip-hip designer brand bastards, come down from the foamy bubbles\nHey you brats, your crappy rap is a burden to others\nTake a break and wait, just go to Hawaii, go home",
      "kr_lyrics": "힙합 진품명품 새끼들아, 거품 위에서 내려와\n야 이 개구쟁이들아, 개구진 니 랩은 그냥 신세 타령\n니가 기다려온 시간 쉬다 오렴 (니가 가라 하와이) 집에 가렴"
    },
    {
      "name": "Spine Breaker",
      "spotify": "https://open.spotify.com/track/1srYOWykolKZnA6SAN1GiA",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/a05cc912735f13060fce249d178861c3fd8ebda0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Whatever you wear, I understand but you’re too much\nYou’re gonna regret it\nYou can keep your swag on but how about your parents?",
      "kr_lyrics": "뭘 입어도 이해해 근데 넌 너무 배가 부른 상태\n어 체해, 후회해\n넌 계속 swag해, 허나 부모 맘은 배제해?"
    },
    {
      "name": "Jump",
      "spotify": "https://open.spotify.com/track/6bv8GUc337blg2QcskhdAJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/31b7d8982ded01e9ff6f4fd96aa11181d7e2a96c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "No matter who tries to stop me\nI will go on my way (What)\nYou only live once (What)",
      "kr_lyrics": "누가 나를 막아도 (What?)\n나의 갈 길을 간다고 (What?)\n인생 한 방이라고"
    },
    {
      "name": "Outro: Propose",
      "spotify": "https://open.spotify.com/track/7EW03rmUEfPIFSxuzZQsgA",
      "cover": "https://i.scdn.co/image/ab67616d00001e027fc4a9420eb2ca3aceafa88b",
      "audio": "https://p.scdn.co/mp3-preview/e1150cc699739c1d790979a9f700b5f1323c8b34?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Although it was a bit awkward, I want to give it all to you\nI give it to you",
      "kr_lyrics": "조금 어색했었지만 이젠 다 주고 싶어\nI give it to you"
    },
    {
      "name": "Intro: Skool Luv Affair",
      "spotify": "https://open.spotify.com/track/7vG0yTvfZZtQ4DoSyy5a61",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/92e27e50992c157489f0ca9db465f84b89b94f1f?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "In a word, this is Bangtan style",
      "kr_lyrics": "이게 한 마디로 방탄 style"
    },
    {
      "name": "Boy in Luv",
      "spotify": "https://open.spotify.com/track/3FnDv33WrrMtuEr7hNR3ev",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/4fc3cb0426bed70ec502d5587f3c4f001826e912?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "So that my heart can reach you, I’m going to run to you now",
      "kr_lyrics": "나의 마음이 네게 닿도록 지금 달려갈 거야"
    },
    {
      "name": "Where You From",
      "spotify": "https://open.spotify.com/track/0nZaV8LwxHeg8TqFy193IL",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/980158403e554cfe674feb21e5d435789e6e9d60?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Here in Seoul, and there in Jeju Island, people all love, oh yeah",
      "kr_lyrics": "여기 서울에도 저기 제주도에도 다 사랑을 하잖아 oh yeah"
    },
    {
      "name": "Just One Day",
      "spotify": "https://open.spotify.com/track/6t7WriKgVszATnrdBKSUAf",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/6057beede87a02dfadd9d571da5411ee1cd6de71?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Our BGM is the sound of breathing",
      "kr_lyrics": "우리의 bgm은 숨소리"
    },
    {
      "name": "Tomorrow",
      "spotify": "https://open.spotify.com/track/0JkTVcN5kilfMztDb3bKZk",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/28a7c0aeddbcc6a632d9d397021236b34a04c2ab?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Because the dawn right before the sunrise is the darkest",
      "kr_lyrics": "해가 뜨기 전 새벽이 가장 어두우니까"
    },
    {
      "name": "BTS Cypher Pt.2: Triptych",
      "spotify": "https://open.spotify.com/track/41eoHn3yTDYMV9hFn50ef4",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/d33036118eb2e549209234351e102bdec6420565?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "All the style and trend are because of Bangtan",
      "kr_lyrics": "모든 스타일과 흐름은 다 방탄 때문에"
    },
    {
      "name": "Spine Breaker",
      "spotify": "https://open.spotify.com/track/0F3Dpp18yIxIm7XRmn0LBj",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/a05cc912735f13060fce249d178861c3fd8ebda0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Wow, I feel good, trying on your dirty clothes",
      "kr_lyrics": "Wow 기분 좋아 걸쳐보는 너의 dirty clothes"
    },
    {
      "name": "Jump",
      "spotify": "https://open.spotify.com/track/1jZZm43y7RPuwjJQ5LrGHe",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/31b7d8982ded01e9ff6f4fd96aa11181d7e2a96c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We’ve finally met, we’re hero-wannabe rappers",
      "kr_lyrics": "비로소 만났지 우린 영웅 지망생 랩퍼"
    },
    {
      "name": "Outro: Propose",
      "spotify": "https://open.spotify.com/track/3x0SuB95K0XewiAKwNEiMZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ab9433cc4b9cda9431be879a",
      "audio": "https://p.scdn.co/mp3-preview/e1150cc699739c1d790979a9f700b5f1323c8b34?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It was a bit awkward, but now I want to give it all to you",
      "kr_lyrics": "조금 어색했었지만 이젠 다 주고 싶어"
    },
    {
      "name": "Intro: O!RUL8,2?",
      "spotify": "https://open.spotify.com/track/3FdanLGasOj37Xi316GfZ4",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/d6811821ce6578e6894cb22152195f30a13ac852?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "This is real, neither a gamble nor a game",
      "kr_lyrics": "이건 진짜야 도박도 게임도 아냐"
    },
    {
      "name": "N.O",
      "spotify": "https://open.spotify.com/track/7JosxtkCqIQieNWXA2Dj3v",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/3babd99639b50ff768799664e5c4808015d6decc?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The word “later” can’t do anything anymore",
      "kr_lyrics": "더는 나중이란 말로 안 돼"
    },
    {
      "name": "We On",
      "spotify": "https://open.spotify.com/track/29vOLabxvytbI8fX9xgTaD",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/f80280ceb263ad3b9e1e55b9c208afc760970dd4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Don’t worry about me, I’m doing better than you",
      "kr_lyrics": "나는 걱정 마, 좋아 너보다"
    },
    {
      "name": "If I Ruled the World",
      "spotify": "https://open.spotify.com/track/4bLtrrVDspeDNSaHGGMQkB",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/94786b633fe7ece8ab4076a82eb437d9c3ea9246?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Soon I’m going to give these dreams to myself as a gift",
      "kr_lyrics": "이런 꿈들을 이젠 내게 곧 선물하겠어"
    },
    {
      "name": "Coffee",
      "spotify": "https://open.spotify.com/track/4eqHEzFsCCiGALC1MHbqnU",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/2c967505648d74a9527d550ed28c1374fff1ffa0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The glass filled with memories that got only bitter with each sip",
      "kr_lyrics": "맛볼수록 쓰기만 했던 추억이 담긴 잔"
    },
    {
      "name": "BTS Cypher Pt.1",
      "spotify": "https://open.spotify.com/track/3KkbZok84es6JqI5aiLj1g",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/0c48a91fec7507f68823345e6a18c5cf1e8cfb14?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Rap Monster, Randa, leader, RapMon, your daddy",
      "kr_lyrics": "랩몬스터, 란다, 리다, 랩몬, 니 아빠"
    },
    {
      "name": "Attack on Bangtan",
      "spotify": "https://open.spotify.com/track/06PapYCtVDlprJPgGELabn",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/32b0193969d2850e0566daf9a3d4654d89166ee6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If you don't know us, then take a good look",
      "kr_lyrics": "우릴 모른다면 제대로 알아둬"
    },
    {
      "name": "Paldogangsan",
      "spotify": "https://open.spotify.com/track/3VlYMpSmYooLpzLiRBBfbX",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/9ae80c404b6ff2e98388fda3b65035624eac67b0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Only ours goes with English, yall never understand it",
      "kr_lyrics": ""
    },
    {
      "name": "Outro: Luv in Skool",
      "spotify": "https://open.spotify.com/track/2ZiVvIvwAwNRL4dUO3TaF6",
      "cover": "https://i.scdn.co/image/ab67616d00001e0238a73fb596e530ac18446812",
      "audio": "https://p.scdn.co/mp3-preview/2e81e7ee949101889b706b43ef20a04f48b6de53?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It still feels like a dream, oh baby",
      "kr_lyrics": "아직도 꿈인 것 같아 oh baby"
    },
    {
      "name": "Intro: 2 Cool 4 Skool",
      "spotify": "https://open.spotify.com/track/1UlnDZ5ubsSX3xrXu063dZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e022666df197eac73ae823e1e67",
      "audio": "https://p.scdn.co/mp3-preview/f824d82317b06b70aa97054a2d55610b24f0c93d?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "We tell our story in a carefree way on behalf of those in their 10s and 20s, you take that",
      "kr_lyrics": "10대 20댈 대신해 쉽게 우리 얘길 해 you take that"
    },
    {
      "name": "We Are Bulletproof Pt.2",
      "spotify": "https://open.spotify.com/track/5pjHS3EpHurMyIpB2QBnEd",
      "cover": "https://i.scdn.co/image/ab67616d00001e022666df197eac73ae823e1e67",
      "audio": "https://p.scdn.co/mp3-preview/478349caf91b1f41b93548a51c323ccb2d0d6ad8?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Oh! Throw stones at me if you’ve ever worked as hard as I have",
      "kr_lyrics": "Oh! 나만치 해 봤다면 돌을 던져"
    },
    {
      "name": "No More Dream",
      "spotify": "https://open.spotify.com/track/089PFeXotzDLNQz9NCk6pF",
      "cover": "https://i.scdn.co/image/ab67616d00001e022666df197eac73ae823e1e67",
      "audio": "https://p.scdn.co/mp3-preview/79215d224c53352ca68be27bf71b4b55441fd580?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Okay, mom, I told you I’m on my way to the library now",
      "kr_lyrics": "알았어 엄마 지금 독서실 간다니까"
    },
    {
      "name": "Like",
      "spotify": "https://open.spotify.com/track/55Ctj6nVfobn9AcPe6sLG2",
      "cover": "https://i.scdn.co/image/ab67616d00001e022666df197eac73ae823e1e67",
      "audio": "https://p.scdn.co/mp3-preview/fdd84ca2c8c66669d5197493a06252b05b04fddf?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "The tag in the photo of you and your new boyfriend",
      "kr_lyrics": "새 남친과 찍은 사진 속 tag tag"
    },
    {
      "name": "My Universe",
      "spotify": "https://open.spotify.com/track/7btzRuXC6Ed3rIyomBRkO2",
      "cover": "https://i.scdn.co/image/ab67616d00001e02fb7fdc6524b1224cc04985f5",
      "audio": "https://p.scdn.co/mp3-preview/c5f3807d36abd0365d49e8c45d51b11a1a5384b9?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "And we will follow you, embroidering this long night",
      "kr_lyrics": "우리는 너를 따라 이 긴 밤을 수놓을 거야"
    },
    {
      "name": "Permission to Dance",
      "spotify": "https://open.spotify.com/track/3XYRV7ZSHqIRDG87DKTtry",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a7e481899b7e0396f93d10b8",
      "audio": "https://p.scdn.co/mp3-preview/4fd3d9d44ec4beaa1483be6c5fa5ff068ad4c721?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "When the nights get colder and the rhythms got you falling behind",
      "kr_lyrics": ""
    },
    {
      "name": "Butter",
      "spotify": "https://open.spotify.com/track/1hciAV5LrrTkRV0g0StZ6h",
      "cover": "https://i.scdn.co/image/ab67616d00001e02bdf6dec3f970dee33308c0a8",
      "audio": "https://p.scdn.co/mp3-preview/e93bc746bea9688b7b1ac5648cd678f74a0d1933?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Rolling up the party, got the right vibe",
      "kr_lyrics": ""
    },
    {
      "name": "Film out",
      "spotify": "https://open.spotify.com/track/3UHPGOkUcE4hE7sqBF4Snt",
      "cover": "https://i.scdn.co/image/ab67616d00001e0234938530af5d2d98acf174fc",
      "audio": "https://p.scdn.co/mp3-preview/815bfcf07fa89b8c28516bfc5188bca1b45a9e69?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "You, as you rise to the surface of my mind are ever so vivid",
      "kr_lyrics": "浮かび上がる君は あまりに鮮やかで"
    },
    {
      "name": "Dynamite",
      "spotify": "https://open.spotify.com/track/72wqLtMtkrB0qUw6jSqM0Z",
      "cover": "https://i.scdn.co/image/ab67616d00001e02ca8a9f328a1971cc6352b963",
      "audio": "https://p.scdn.co/mp3-preview/d8777ce6505aa52625472591ca898146bf3b0914?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Life is sweet as honey",
      "kr_lyrics": ""
    },
    {
      "name": "Stay Gold",
      "spotify": "https://open.spotify.com/track/0UwQTbq7ZtBJ7v530mpaxP",
      "cover": "https://i.scdn.co/image/ab67616d00001e02179c168e6a41c4cccf5ff729",
      "audio": "https://p.scdn.co/mp3-preview/ffcfd8dcde08e241d34546b4fb697a54649563fb?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Those eyes are diamonds, more beautiful than any gem",
      "kr_lyrics": "その瞳はダイヤ どんな宝石よりも Beautiful"
    },
    {
      "name": "SUGA's Interlude",
      "spotify": "https://open.spotify.com/track/5a0nHa7F4S9hb0Zi0zLS8w",
      "cover": "https://i.scdn.co/image/ab67616d00001e02da43139cbb1612e1b94eed4a",
      "audio": "https://p.scdn.co/mp3-preview/c96be0561976bbad6534b45da07939603f5ac939?cid=774b29d4f13844c495f206cafdad9c86",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "never forget that the stars you longed for only rise in the darkness",
      "kr_lyrics": "네가 바란 별들은 어둠 속에서만 뜬다는 걸 절대 잊지 마"
    },
    {
      "name": "Waste It On Me",
      "spotify": "https://open.spotify.com/track/2FWyJIT0gL2G3xWVQ9Id5f",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c8b803e91fcdda908c18232f",
      "audio": "https://p.scdn.co/mp3-preview/7f0721ba9eafbcdccf30bccaf4c8c06c2888fe2a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I don't know your secrets but I'll pick up the pieces",
      "kr_lyrics": ""
    },
    {
      "name": "Good Day",
      "spotify": "https://open.spotify.com/track/3KWYKrNuIGg2QmlwLBkrTF",
      "cover": "https://i.scdn.co/image/ab67616d00001e0280b815a027a149e2bb2f6a1d",
      "audio": "https://p.scdn.co/mp3-preview/417b7d73481ab40f0aa386dedad9021980717c56?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If we’re connected, surely it’ll be brighter tomorrow",
      "kr_lyrics": "君と繋がってよう きっとbrighter tomorrow"
    },
    {
      "name": "For You",
      "spotify": "https://open.spotify.com/track/43x0i2PPXrmOGTTgoyqGNZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e028372f07e4d18b15d3debc925",
      "audio": "https://p.scdn.co/mp3-preview/dc69b6a9843667812e3b1d9078cb96b22f4d9dd8?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Fluttering down (the shower of flower petals)",
      "kr_lyrics": "ヒラヒラ舞う (花びらのshower)"
    },
    {
      "name": "Heartbeat (BTS World Original Soundtrack)",
      "spotify": "https://open.spotify.com/track/5EgYDyMDCi8X0zDydTF7Rb",
      "cover": "https://i.scdn.co/image/ab67616d00001e026fca8304dc8899561b7e6c8c",
      "audio": "https://p.scdn.co/mp3-preview/b43e488f9e2bab595268d0b28f9f117cb164a419?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Just like yesterday, don’t let go of this hand ever again",
      "kr_lyrics": "어제처럼 다시 이 손 놓지 말고"
    },
    {
      "name": "Dream Glow (BTS World Original Soundtrack) [Pt. 1]",
      "spotify": "https://open.spotify.com/track/6xtmK2QQfRd7xCwyejl2oV",
      "cover": "https://i.scdn.co/image/ab67616d00001e026fca8304dc8899561b7e6c8c",
      "audio": "https://p.scdn.co/mp3-preview/805760fa8cb4831ce5ee421868832c4dd96679d4?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Keep on shining make it brighter than a spotlight",
      "kr_lyrics": ""
    },
    {
      "name": "A Brand New Day (BTS World Original Soundtrack) [Pt. 2]",
      "spotify": "https://open.spotify.com/track/4g4ME9bHxuhzZMfNHlHlb5",
      "cover": "https://i.scdn.co/image/ab67616d00001e026fca8304dc8899561b7e6c8c",
      "audio": "https://p.scdn.co/mp3-preview/0bfb90b37ba3f7016eb805370105eef592385999?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Will I be able to overcome all the fears and panic?",
      "kr_lyrics": "무서움과 두려움 다 헤쳐 나아 갈 수 있을까?"
    },
    {
      "name": "All Night (BTS World Original Soundtrack) [Pt. 3]",
      "spotify": "https://open.spotify.com/track/2r4XO0I2KmvO16HGSKdf54",
      "cover": "https://i.scdn.co/image/ab67616d00001e026fca8304dc8899561b7e6c8c",
      "audio": "https://p.scdn.co/mp3-preview/a51fc0f48ea66bd3c1985ec57e4a53e3d5f65764?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Inspiration, wait for me, I’ll catch you all mine",
      "kr_lyrics": "영감아 기다려 널 잡을게 all mine"
    },
    {
      "name": "Change",
      "spotify": "https://open.spotify.com/track/4L3HQD7tbXCPpO9Ps7rgdm",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e9cd03556579e99c0b1defa0",
      "audio": "https://p.scdn.co/mp3-preview/35d66bef83a5d1a89fb72f190c31f4eb93e55bdf?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "All we got is mad teachers and some visible classes",
      "kr_lyrics": ""
    },
    {
      "name": "tokyo",
      "spotify": "https://open.spotify.com/track/3RvScmBWbdbnOVMF6FMcXI",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/4f31b14fc01ae546e70ed0ddd4ed995b9ded99fd?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Do I miss myself? Do I miss your face?",
      "kr_lyrics": ""
    },
    {
      "name": "seoul (prod. HONNE)",
      "spotify": "https://open.spotify.com/track/4VcKLbECzwOQTYe3Sut6xJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/8de71ede59894b0fcdef870c06acc5db6f004cec?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m leavin’ you, I’m livin’ you",
      "kr_lyrics": ""
    },
    {
      "name": "moonchild",
      "spotify": "https://open.spotify.com/track/4fwYALz7GwmXgS8QTRjDEJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/b5ddb46639af9ec0f1b48b3a40d58b797e68b75e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Yeah, all the pain and all the sorrow that’s our destiny, see?",
      "kr_lyrics": ""
    },
    {
      "name": "badbye",
      "spotify": "https://open.spotify.com/track/7L8JKDh4yB5rCcg2Rp4yvz",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/5d8ee22a0a0074df0499ff9809f113eccf3a0f56?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Kill me kill me softly",
      "kr_lyrics": ""
    },
    {
      "name": "uhgood",
      "spotify": "https://open.spotify.com/track/5vI1exL3zFhqFWDSL9fq5H",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/141d708a3d24353a3367c2f5dfdf3f982117d736?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "But, I still want to cross the bridge and reach me",
      "kr_lyrics": "그래도 다리 건너 내게 닿고 싶어"
    },
    {
      "name": "everythingoes",
      "spotify": "https://open.spotify.com/track/7bSJAuXjyhlTcz5CfoNDdt",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/9387430f45919f50dbfd19857dabe391790edf02?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I pray that it shall pass just like all these winds",
      "kr_lyrics": "그저 이 모든 바람 바람처럼 지나가길 I pray"
    },
    {
      "name": "forever rain",
      "spotify": "https://open.spotify.com/track/0MBLKSjisnYtP4J6KYYT1T",
      "cover": "https://i.scdn.co/image/ab67616d00001e02e1261739d0e6b2d0ae7cdeae",
      "audio": "https://p.scdn.co/mp3-preview/98a8c6a0cd8192df29e149d199ee0897ad7b27a6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "When you come down, I don’t feel lonely",
      "kr_lyrics": "니가 내리면 외롭지 않아"
    },
    {
      "name": "WINTER FLOWER(Feat.RM)",
      "spotify": "https://open.spotify.com/track/4Eefey3uN90Abhbr47zKmC",
      "cover": "https://i.scdn.co/image/ab67616d00001e024b89d54636763c641bce87e5",
      "audio": "https://p.scdn.co/mp3-preview/6e23c2493f04cac7a7c0589a9b10b2999e7a3a05?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’ll call with all my might for an autumn that resembles you",
      "kr_lyrics": "힘껏 불러올게 너를 닮았던 가을을"
    },
    {
      "name": "Don't (feat. RM)",
      "spotify": "https://open.spotify.com/track/6KE3Fs6LMzi4hJI3eFqyLC",
      "cover": "https://i.scdn.co/image/ab67616d00001e027606e1056c60ff26471545d9",
      "audio": "https://p.scdn.co/mp3-preview/13e39b5a9dce1ff452cc43e1454ef49944e3f96a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Can’t you stay as a pebble here?",
      "kr_lyrics": "여기 조약돌로 남아주면 안 돼요"
    },
    {
      "name": "Crying Over You ◐ (feat. RM & BEKA)",
      "spotify": "https://open.spotify.com/track/7AyaV1Ga66yguStIr20zsO",
      "cover": "https://i.scdn.co/image/ab67616d00001e02387b8b58dfac97a9a10466cd",
      "audio": "https://p.scdn.co/mp3-preview/f0204d7095d15349e09ffd9d8c91cf68078d762b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Guess life's like this, shit happens and we look for the magic",
      "kr_lyrics": ""
    },
    {
      "name": "Hope World",
      "spotify": "https://open.spotify.com/track/5UMPPsXaGbR1qtzcnEtTpM",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/4d9251055e5ae9a604e7581c9d3a51655a87c4d0?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Whoever you are, let’s travel around the world",
      "kr_lyrics": "그 누가 됐던 돌자 세상 한 바퀴"
    },
    {
      "name": "P.O.P (Piece Of Peace) Pt. 1",
      "spotify": "https://open.spotify.com/track/78GQP9XBSqpEDlMoPAbUAJ",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/03891f88559fef8122894f5bd33a92b0f800cd35?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Like a piece of cake that is simple and filling",
      "kr_lyrics": "단순하고 쉽게 배가 차는 케이크 조각처럼"
    },
    {
      "name": "Daydream (백일몽)",
      "spotify": "https://open.spotify.com/track/56sdcbPR74RxqmKVbQzJ8s",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/6a172f2b517fd70089265d31178df50837d61a76?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If there’s the sun, I would want to dream",
      "kr_lyrics": "해가 있다면 꿈을 꾸고 싶다고"
    },
    {
      "name": "Base Line",
      "spotify": "https://open.spotify.com/track/3eSCPt6StovDAIps2XhZ2Z",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/b6c2972bd77f3581ec2edc4704bb6dc13b770d14?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I don’t need your hate code",
      "kr_lyrics": ""
    },
    {
      "name": "항상 (HANGSANG)",
      "spotify": "https://open.spotify.com/track/270k38FpoKhnvZLv50NlTr",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/4a4f58b657ed41484da8ab311f289d81060c4d13?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Red road when I open my eyes",
      "kr_lyrics": "눈 뜨면 Red road"
    },
    {
      "name": "Airplane",
      "spotify": "https://open.spotify.com/track/2jk6oBuLiCZJTDWhlJEzIw",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/0eaadfc525e49dc0a009df1cf16ddeb4911a8faf?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Gwangju native’s big admiration for aviation",
      "kr_lyrics": "광주 토박이의 비행 삼매경"
    },
    {
      "name": "Blue Side (Outro)",
      "spotify": "https://open.spotify.com/track/20zr2Oef3PVeGRxjmSF5CC",
      "cover": "https://i.scdn.co/image/ab67616d00001e02a2de0bc4a200af9490caa662",
      "audio": "https://p.scdn.co/mp3-preview/c5818bbcef75a91d5229bc1c7fc093e1f084552c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "In my blue dream I will hold you",
      "kr_lyrics": "내 파란 꿈속에 널 안을래"
    },
    {
      "name": "Chicken Noodle Soup (feat. Becky G)",
      "spotify": "https://open.spotify.com/track/2y6Ty2NPAsP84XJAtzLxuk",
      "cover": "https://i.scdn.co/image/ab67616d00001e021338a7212b8c4d2c2a11d723",
      "audio": "https://p.scdn.co/mp3-preview/1395fda028d34fc16a9248acb2be2bf9e08a5f6a?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "My height is measured by dance, I’m okay",
      "kr_lyrics": "내 키는 춤으로 매겨 I’m okay"
    },
    {
      "name": "It's Definitely You",
      "spotify": "https://open.spotify.com/track/2LowwiemmGMzzNSH1PJprK",
      "cover": "https://i.scdn.co/image/ab67616d00001e028dd6de651baf8860665f8003",
      "audio": "https://p.scdn.co/mp3-preview/c5df8a75d1dc70c5be4014010f90ee9148884ad1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Please take me into the scattered light",
      "kr_lyrics": "흩어져버린 빛 속으로 날 데려가 줘"
    },
    {
      "name": "Sweet Night",
      "spotify": "https://open.spotify.com/track/39EXZNMxb4RBHlRjnRaOKp",
      "cover": "https://i.scdn.co/image/ab67616d00001e0220af30dc4a6011fc11632211",
      "audio": "https://p.scdn.co/mp3-preview/5b4c57f4ad5015bd143b62c3e225b3d001773bd1?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I wanna ask you if this is all just in my head",
      "kr_lyrics": ""
    },
    {
      "name": "Christmas Tree",
      "spotify": "https://open.spotify.com/track/186NCtNk1tUYS7c2DxgJ7O",
      "cover": "https://i.scdn.co/image/ab67616d00001e028764ebc69bd91a01cc3948a2",
      "audio": "https://p.scdn.co/mp3-preview/77142868330d0a8fb8c38c90aca96f046d79cb88?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "It always comes around as I believed",
      "kr_lyrics": ""
    },
    {
      "name": "Yours",
      "spotify": "https://open.spotify.com/track/10IfXtjKQmOiON7tNAHv0y",
      "cover": "https://i.scdn.co/image/ab67616d00001e0254260e31027fc151dcb7161e",
      "audio": "https://p.scdn.co/mp3-preview/f33456a72a390d7618e2252e6e2c43b2aa34357c?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Every night I see you in my heart",
      "kr_lyrics": ""
    },
    {
      "name": "Moonlight",
      "spotify": "https://open.spotify.com/track/057xGYST5exVyNevufrioZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/a0932e2bc9fcd337c4c56b41b81a102a7bfc9ddf?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A Peter Pan who still can’t wake up from his dream",
      "kr_lyrics": "아직도 꿈에서 깨지 못하는 피터팬"
    },
    {
      "name": "Daechwita",
      "spotify": "https://open.spotify.com/track/1Y7AZ3akqDipAyo6mmOQTy",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/97b4440c93f675bd6d574ccaa656429dce8ca686?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Our Bang Sihyuk PD dance, ce, ce, ce, ce, ce, ce, every day",
      "kr_lyrics": "우리 방시혁 피디는 매일 춤춤춤춤춤춤춤"
    },
    {
      "name": "What do you think?",
      "spotify": "https://open.spotify.com/track/5LtrXmU6LXHHbpb7puYNvA",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/a85389baa7334030a94a1c1d785296c7e8ea93b7?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I don’t necessarily do flexing, but on a chartered airplane, so fly",
      "kr_lyrics": "굳이 하지 않아 난 flexing but 전세기 so fly"
    },
    {
      "name": "Strange (feat. RM)",
      "spotify": "https://open.spotify.com/track/6x2arhzc99oGlqM82V0mnd",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/538a440b2047b6a05e3a39fabbb2037da2dd1f29?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A round nail that’s been hammered into a square hole",
      "kr_lyrics": "네모난 구멍에 박혀버린 동그란 못"
    },
    {
      "name": "28 (feat. NiiHWA)",
      "spotify": "https://open.spotify.com/track/3AqSBtredpPyT18rEYl1vK",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/f3e92a8d5c0b142bf4d021eb41768d3cb0eed0ec?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Though I’m breathing, it feels like my heart has broken down",
      "kr_lyrics": "숨은 쉬는데 심장은 고장이 난 것 같은데"
    },
    {
      "name": "Burn It (feat. MAX)",
      "spotify": "https://open.spotify.com/track/38iufYNK4hUzS649Oe2kZy",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/18f505141a9fb40606fb1a9cce7148edd6c50622?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "maybe only the ashes would remain, or maybe it would remain the same",
      "kr_lyrics": "재만 남을지도 모르지 아님 그대로일지"
    },
    {
      "name": "People",
      "spotify": "https://open.spotify.com/track/4wDSEE082RPcnhXzPzFhCp",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/379c5f136cc06297062ae68acd5fbe0c2058819e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "If you live like that, what about it",
      "kr_lyrics": "그렇게 살면 뭐 어때"
    },
    {
      "name": "Honsool",
      "spotify": "https://open.spotify.com/track/5ErGQcHEA8ws2rVp3Xx06Z",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/4230246ccaae16dcd79f0d2f20e6191fee71bb43?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Now I’m feelin’ like I’m flyin’",
      "kr_lyrics": ""
    },
    {
      "name": "Interlude : Set me free",
      "spotify": "https://open.spotify.com/track/4xAt9CoV83PT6U9JvcauLZ",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/46ce3857aea7ca3825fb71d0553e89904c983d23?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I’m floating freely in the void",
      "kr_lyrics": "난 자유롭게 허공에 떠있네"
    },
    {
      "name": "Dear my friend (feat. Kim Jong Wan of NELL)",
      "spotify": "https://open.spotify.com/track/5lw1xIqEvmVdmnNzmv1KJf",
      "cover": "https://i.scdn.co/image/ab67616d00001e026c0e2c778e672701e1a254c6",
      "audio": "https://p.scdn.co/mp3-preview/29c813addca4125ceb88fcb37d39db90db7815a3?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "would we have remained as friends? what would it have been like?",
      "kr_lyrics": "우리는 아직도 친구일까 어땠을까"
    },
    {
      "name": "Agust D",
      "spotify": "",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/agustd102",
      "is_soundcloud": "TRUE",
      "en_lyrics": "My tongue technology that sends you to Hong Kong",
      "kr_lyrics": "홍콩을 보내는 my tongue technology"
    },
    {
      "name": "Give It to Me",
      "spotify": "https://open.spotify.com/track/1Y84lXBGSuri3tDPUkFwXT",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/ce0460218b658f312f8e506358b056973fd1e4b9?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Anything is fine, just bring it to me",
      "kr_lyrics": "뭐든 좋으니까 가져와"
    },
    {
      "name": 724148,
      "spotify": "https://open.spotify.com/track/4wvHmcBp5FKNeJUzigEH7s",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/cf74ce5437729ea10078178f159e3dfebb52fac6?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "What kind of company would, hmm? would say it doesn’t want a genius like this?",
      "kr_lyrics": "그 어떤 회사가 말야 응? 이런 천재를 싫다고 하겠어"
    },
    {
      "name": "140503 at Dawn",
      "spotify": "https://open.spotify.com/track/3i4XQx4K1g6Z0yFOzFk2Tu",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/94c5ba2a2297fc89de97619fbd6e12a48c72f1c5?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "I built a wall in front of me, “Don’t come inside”",
      "kr_lyrics": "하며 내 앞에 놓아 버린 벽 들어오지마"
    },
    {
      "name": "The Last",
      "spotify": "https://open.spotify.com/track/5GPiG4vIuDfYus1gRcXEok",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/8fb72383d04e46289d27163b7ec15df6f56e0712?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Some people stop my mouth and ask me to swallow the forbidden fruit",
      "kr_lyrics": "어떤 이들은 내 입을 틀어 막으며 선악과를 삼키라 해"
    },
    {
      "name": "Tony Montana",
      "spotify": "https://open.spotify.com/track/2EIxlkSRyejFdD2Rp1Mmza",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/389872ff6d9529b8e35e3c8ec804eb576e55277e?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "now the entire world is in my god damn hands",
      "kr_lyrics": "이제 전세계가 god damn 내 손안에"
    },
    {
      "name": "So Far Away",
      "spotify": "https://open.spotify.com/track/6iFsAGMsGLvLesAhzTcRpl",
      "cover": "https://i.scdn.co/image/ab67616d00001e027a23b0944eb5c199cf5cbc09",
      "audio": "https://p.scdn.co/mp3-preview/54591a7aa1531c3afcd83a6ecb46f54a0d392329?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Why am I here alone when everyone else is running",
      "kr_lyrics": "모두가 달리는데 왜 나만 여기 있어"
    },
    {
      "name": "Blueberry Eyes (feat. SUGA of BTS)",
      "spotify": "https://open.spotify.com/track/5dn6QANKbf76pANGjMBida",
      "cover": "https://i.scdn.co/image/ab67616d00001e029660ae57836f713884d86cbb",
      "audio": "https://p.scdn.co/mp3-preview/3e2bcb00dac7dedb26319f9e95dc3f7ff9066865?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Friends who hold each other up, who are each other’s anchor",
      "kr_lyrics": "서롤 지탱하는 벗 서로의 닻"
    },
    {
      "name": "Song Request 신청곡 (feat. SUGA of BTS)",
      "spotify": "https://open.spotify.com/track/6Au7CCNN2wXgCNxdavgxDM",
      "cover": "https://i.scdn.co/image/ab67616d00001e023694e520c30f4eff71742f10",
      "audio": "https://p.scdn.co/mp3-preview/80ae034b79854679741aebe3fa48f523feee6cb7?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "That’s right, to someone I am spring, to another winter",
      "kr_lyrics": "그래 난 누군가에겐 봄 누군가에게는 겨울"
    },
    {
      "name": "eight(Prod.&Feat. SUGA of BTS)",
      "spotify": "https://open.spotify.com/track/0pYacDCZuRhcrwGUA5nTBe",
      "cover": "https://i.scdn.co/image/ab67616d00001e02c63be04ae902b1da7a54d247",
      "audio": "https://p.scdn.co/mp3-preview/d2a06f04dd58be7d6927c6beba45df23a1d7067b?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "A goodbye is like a disaster text alert",
      "kr_lyrics": "작별은 마치 재난문자 같지"
    },
    {
      "name": "Stay Alive (Prod. SUGA of BTS)",
      "spotify": "https://open.spotify.com/track/7CAdT0HdiQNlt1C7xk2hep",
      "cover": "https://i.scdn.co/image/ab67616d00001e028916a2bb404bed6755f2bbbd",
      "audio": "https://p.scdn.co/mp3-preview/876a22b9339616e34cc89cbd14556f3f46131f07?cid=bbfee10b51fe4668b1866f294215c3d6",
      "soundcloud": "",
      "is_soundcloud": "FALSE",
      "en_lyrics": "Even if my feet bleed, I will stay by your side, so",
      "kr_lyrics": "나의 발에 피 나도 너의 곁에 나 있음에"
    },
    {
      "name": "Super Tuna",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-ztRRrta2023mT7C4-ltMHYg-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/KdSDYa0VSVPH7ggkEOdfJwnxkIlKN6oU",
      "soundcloud": "https://soundcloud.com/bangtan/supertuna-by-jin-of-bts",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Hyung, hyung, please take me with you",
      "kr_lyrics": "형, 형 나 좀 데려가요"
    },
    {
      "name": "Bicycle",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-9qpR6pPCZOWYlKSV-rSozgA-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/ZP2wWrtOnrLeAYG54yEFXDvb1Ti0hwQF",
      "soundcloud": "https://soundcloud.com/bangtan/bicycleforarmy?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Getting it roll with my two feet",
      "kr_lyrics": "두 발을 구르며"
    },
    {
      "name": "Snow Flower",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-0r6hjcT7hOyGUrfm-RdfmMg-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/1pnnZo56HoZTeWTRkT2ZovDBzTBrasUW",
      "soundcloud": "https://soundcloud.com/bangtan/snow-flower-by-v-of-bts-feat-peakboy?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Christmas without you would just not be Christmas at all\nBright mistletoes up above us, it’s just you and me",
      "kr_lyrics": ""
    },
    {
      "name": "Christmas Love",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-5uw1Ki48bhtAf0H4-DcrEHw-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/vCYupHBgKcgpVAAFo1eW1AMx64r39Z3S",
      "soundcloud": "https://soundcloud.com/bangtan/christmas-love-by-jimin-of-bts?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Like the white snow, \nfalling falling,",
      "kr_lyrics": "흰 눈처럼\n소복소복"
    },
    {
      "name": "Abyss",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-5iy7EBZnYztTuAdW-mdUe3g-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/uJbcC0aQxfi57G3zmoC3XRJJTZSsiHFU",
      "soundcloud": "https://soundcloud.com/bangtan/2020jinbirthday?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "The closer I get to you, the more breathless I become and the farther away you feel",
      "kr_lyrics": "너에게 갈수록 숨이 차오르고 넌 더 멀어지는 것 같아"
    },
    {
      "name": "Still With You",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-7nmc0L048KDmtv7Q-aSOK7A-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/vQKcscFwsYNlmLyWBlYTramsU8syEZCp",
      "soundcloud": "https://soundcloud.com/bangtan/thankyouarmy2020?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "I still wanted to stay in your sky like a star",
      "kr_lyrics": "별처럼 너의 하늘에 머물고 싶었어"
    },
    {
      "name": "Winter Bear",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000580141127-0hx82w-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/FPg2ODFmFFNp5XHIcDjxCU9ANoGhgY7g",
      "soundcloud": "https://soundcloud.com/bangtan/kimv02?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "",
      "kr_lyrics": ""
    },
    {
      "name": "Tonight",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000546383487-i1396u-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/jtsh1NjQNXnb2AjcdZxYm3nEsAxto1ES",
      "soundcloud": "https://soundcloud.com/bangtan/tonightbyjin?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "When tonight passes, I’m scared that I might not be able to see you",
      "kr_lyrics": "이 밤이 지나면 널 볼 수 없을까봐 두려워"
    },
    {
      "name": "Scenery",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000480261648-g2r85w-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/4qsp3R6KZqDyVMkTEAfZ5qFbxmnvz7Qx",
      "soundcloud": "https://soundcloud.com/bangtan/kimv01?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "I still wonder wonder beautiful story\n\nStill wonder wonder best part",
      "kr_lyrics": ""
    },
    {
      "name": "Promise",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000465134559-jt1kw8-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/yoeTex5xJFietp9wusny8TOAalHYPTtE",
      "soundcloud": "https://soundcloud.com/bangtan/firstjiminpresent?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "I want you to be your light, baby\nYou should be your light",
      "kr_lyrics": ""
    },
    {
      "name": "DDaeng",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000359060133-vssmky-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/a3dYJssYHGhbwAfI3lD6nzxPUL43wzMO",
      "soundcloud": "https://soundcloud.com/bangtan/ddceremony?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Even if I s- st- stutter because I’m so d- dumbfounded, please e- excuse me I’m a rather p- poor ta- talker",
      "kr_lyrics": "너무 어 얼 탱이가 없어 말을 더 더 더 듬어도 양해르 조 좀 바랄게 내가 말주 벼 변이 좀 부족해"
    },
    {
      "name": "4 O'Clock",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000227394756-h9j8b3-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/rIQoLiUxRkNAWCgdWmKEcuuc8YshkXjN",
      "soundcloud": "https://soundcloud.com/bangtan/4oclockrmv?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "At a park in the half-light of dawn. a nameless singing bird: Where are you",
      "kr_lyrics": "어스름한 공원에 노래하는 이름모를 새 Where are you"
    },
    {
      "name": "always",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000200772577-8jswks-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/xMgd7QJrtc1AHydto6kVdVa64VGuruS0",
      "soundcloud": "https://soundcloud.com/bangtan/always-by-rm?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "I live to understand the world, but the world has never understood me, why",
      "kr_lyrics": "난 세상을 이해하기 위해 사는데 / 세상은 날 이해한 적이 없어 왜"
    },
    {
      "name": "I Know (RM & JK)",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000165194952-ifpkc4-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/M22W2f4ttVgLwh10q4PNt2q7ABn85jEF",
      "soundcloud": "https://soundcloud.com/bangtan/sothatiloveyou?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Know you love me girl, So that I love you. Know you love me boy, So that I love you",
      "kr_lyrics": ""
    },
    {
      "name": "Voice",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/01-1",
      "is_soundcloud": "TRUE",
      "en_lyrics": "this mixtape that is created by me alone in a corner of my room",
      "kr_lyrics": "여전히 방 한 켠에서 혼자 만들어낸 믹스테잎"
    },
    {
      "name": "Do You",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/02-do-you?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Though you’re not perfect, you’re a limited edition LEGO",
      "kr_lyrics": "완벽하진 않아도 한정판 레고"
    },
    {
      "name": "Awakening",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/03-1?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "I hated it at one time but now I love to get that title",
      "kr_lyrics": "한 땐 싫었지만 now I love to get that title"
    },
    {
      "name": "Throw Away",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/QBnCX71PqvhvDqNrnzfefTiuHE3nlJD9",
      "soundcloud": "https://soundcloud.com/bangtan/05-1?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "If you know how to have fun, gather here suckers",
      "kr_lyrics": "니가 즐길 줄 안다면 집합 suckers"
    },
    {
      "name": "Monster",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/04-monster?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Singapore today, Taiwan tomorrow, bitch",
      "kr_lyrics": "오늘은 싱가폴, 내일은 타이완 bitch"
    },
    {
      "name": "Joke",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/06-1?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "This is meaningless wordplay, you know",
      "kr_lyrics": "이건 의미없는 말놀이 you know"
    },
    {
      "name": "Rush (feat. Krizz Kaliko)",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/08-rush-feat-krizz-kaliko?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Young monster just tryna get by",
      "kr_lyrics": ""
    },
    {
      "name": "Life",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/09-life?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Were we born to be wrong?",
      "kr_lyrics": "우린 틀리기 위해 태어난 걸까"
    },
    {
      "name": "Adrift",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/10-1?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Let’s be happy, let’s be happy",
      "kr_lyrics": "행복하자 행복하자"
    },
    {
      "name": "I Believe",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/artworks-000110651310-xdgrv0-t500x500.jpg",
      "audio": "TO-DO: ADD AUDIO",
      "soundcloud": "https://soundcloud.com/bangtan/11-i-believe?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "We’re so used to look only outward, when the galaxy is inside me",
      "kr_lyrics": "우린 밖을 보는 데에만 너무 익숙해 내 안에 은하수가 있는데"
    },
    {
      "name": "So 4 More",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/avatars-000205359015-hyo5wq-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/zyGkh0K3VP1eIlc0ahPWwLfNkDb9CDzd",
      "soundcloud": "https://soundcloud.com/bangtan/so-4-more-by-bts?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Yeah, I’m Sirius, shining brighter than all other stars",
      "kr_lyrics": "그래 난 시리우스, 어떤 별보다도 빛나"
    },
    {
      "name": "Born Singer",
      "spotify": "",
      "cover": "https://i1.sndcdn.com/avatars-000205359015-hyo5wq-t500x500.jpg",
      "audio": "https://audio.jukehost.co.uk/qX8UuKWAFziWs9kZYHMLecple6JjcIsf",
      "soundcloud": "https://soundcloud.com/bangtan/born-singer-bts-130710?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",
      "is_soundcloud": "TRUE",
      "en_lyrics": "Though my body suffers from pain, I can stand it because cheers are coming in",
      "kr_lyrics": "몸이 아파도 버틸만 해 함성들이 밀려오니까"
    }
  ]
